export { a as FexiosError, F as FexiosErrorCodes, b as FexiosResponseError, i as isFexiosError } from '../shared/fexios.B-14qd8n.mjs';
import { i as isPlainObject } from '../shared/fexios.DtQgiOCE.mjs';
export { F as FexiosQueryBuilder } from '../shared/fexios.TxSvO_qH.mjs';
export { F as FexiosResponse, c as createFexiosResponse } from '../shared/fexios.DFl5Gol9.mjs';

var FexiosHeaderBuilder;
((FexiosHeaderBuilder2) => {
  FexiosHeaderBuilder2.makeHeaders = (input) => {
    if (!input) return new Headers();
    if (input instanceof Headers) return new Headers(input);
    const h = new Headers();
    if (input instanceof Map) {
      for (const [k, v] of input.entries()) {
        if (v == null) continue;
        if (Array.isArray(v)) {
          for (const item of v) {
            if (item == null) continue;
            h.append(k, String(item));
          }
        } else {
          h.append(k, String(v));
        }
      }
      return h;
    }
    if (isPlainObject(input)) {
      for (const [k, v] of Object.entries(input)) {
        if (v == null) continue;
        if (Array.isArray(v)) {
          for (const item of v) {
            if (item == null) continue;
            h.append(k, String(item));
          }
        } else {
          h.append(k, String(v));
        }
      }
      return h;
    }
    throw new TypeError(
      "only plain object, Map/ReadonlyMap, or Headers is supported"
    );
  };
  FexiosHeaderBuilder2.toHeaderRecord = (input) => {
    if (input instanceof Headers) {
      const out = {};
      input.forEach((value, key) => {
        out[key] = out[key] ? [...out[key], value] : [value];
      });
      return out;
    }
    if (input instanceof Map) {
      const output = {};
      for (const [key, raw] of input.entries()) {
        if (raw == null) continue;
        if (Array.isArray(raw)) {
          const arr = raw.filter((v) => v != null).map((v) => String(v));
          if (arr.length) output[key] = (output[key] ?? []).concat(arr);
        } else {
          const v = String(raw);
          output[key] = output[key] ? [...output[key], v] : [v];
        }
      }
      return output;
    }
    throw new TypeError(
      `unsupported type transformation, got: ${Object.prototype.toString.call(
        input
      )}`
    );
  };
  FexiosHeaderBuilder2.mergeHeaders = (...incomes) => {
    const output = new Headers();
    const mergeOneFromObject = (patch) => {
      for (const [k, v] of Object.entries(patch)) {
        if (v === void 0) continue;
        if (v === null) {
          output.delete(k);
          continue;
        }
        if (Array.isArray(v)) {
          output.delete(k);
          for (const item of v) {
            if (item == null) continue;
            output.append(k, String(item));
          }
        } else {
          output.set(k, String(v));
        }
      }
    };
    for (const input of incomes) {
      if (input == null) continue;
      if (input instanceof Headers) {
        input.forEach((value, key) => {
          output.set(key, value);
        });
        continue;
      }
      if (isPlainObject(input)) {
        mergeOneFromObject(input);
        continue;
      }
      const rec = (0, FexiosHeaderBuilder2.toHeaderRecord)(input);
      for (const [key, arr] of Object.entries(rec)) {
        output.delete(key);
        for (const v of arr) output.append(key, v);
      }
    }
    return output;
  };
})(FexiosHeaderBuilder || (FexiosHeaderBuilder = {}));

export { FexiosHeaderBuilder };
//# sourceMappingURL=index.mjs.map
